import React, { Component } from "react";


import { Card, CardBody, Col, Container, Row } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import RemoteTable from "../../../components/Common/RemoteTable";
import { getCampaignsVkList, integrationStateInit } from "../../../store/integration/actions";
import ModifiedMetaTags from '../../../components/ModifiedMetaTags/index';

class CampaignVkList extends Component {
  constructor(props) {
    super(props);

    this.nameFilter = null;

    this.state = {
      page: 1,
      sizePerPage: 10,
      filter_name: [],
    };

    this.searchTimer = null;
  }

  componentDidMount() {
    this.props.getCampaignsVkList({ ...this.props.data, search: null });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {}

  componentWillUnmount() {
    this.props.integrationStateInit()
  }

  handleTableChange = (data) => {
    this.props.getCampaignsVkList(data);
  };

  render() {
    const columns = [
      {
        dataField: "id",
        text: "ID",
        sort: true,
      },
      {
        dataField: "name",
        text: "Name",
        sort: true,
      },
      {
        dataField: "type",
        text: "Type",
        sort: true,
      },
      {
        dataField: "status",
        text: "Status",
        sort: true,
      },
      {
        dataField: "create_time",
        text: "Create time",
        sort: true,
      },
      {
        dataField: "update_time",
        text: "Update time",
        sort: true,
      },
    ];

    return (
      <React.Fragment>
        <div className="page-content">
        <ModifiedMetaTags title="Campaigns list | Mobihunter" />

          <Container fluid>
            <Breadcrumbs
              title="Dashboard"
              breadcrumbItem="Campaigns VK"
              link="/dashboard"
            />
            <Row>
              <Col className="col-12">
                <Card>
                  <CardBody>
                    <RemoteTable
                      onTableChange={this.handleTableChange}
                      columns={columns}
                      data={this.props.data}
                      loading={this.props.loading}
                    ></RemoteTable>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

CampaignVkList.propTypes = {
  data: PropTypes.any,
  loading: PropTypes.bool,
  getCampaignsVkList: PropTypes.func,
  integrationStateInit: PropTypes.func,
};

const mapStateToProps = state => ({
  data: state.Integration.dataCampaignVk,
  loading: state.Integration.loading_campaign_vk,
});

export default connect(mapStateToProps, { getCampaignsVkList, integrationStateInit })(CampaignVkList);
